module.exports = __webpack_public_path__ + "media/images/icons/icn_002-2d17352b12a7c0c341fb86001116168f.svg";